import { Check, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data";

const spanClasses = [
  "md:col-span-7",
  "md:col-span-5",
  "md:col-span-5",
  "md:col-span-7",
];

export const Services = () => {
  const scrollToQuote = () => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="services" className="py-24 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <p className="uppercase tracking-[0.2em] text-sm font-semibold text-brand">What we do</p>
          <h2 className="mt-3 font-display font-bold text-4xl md:text-5xl tracking-tight text-slate-900">
            Spotless, top to bottom
          </h2>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">
            One trusted crew for every exterior cleaning job. Bundle services and save on your visit.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-6">
          {SERVICES.map((s, i) => (
            <article
              key={s.key}
              data-testid={`service-card-${s.key}`}
              className={`group relative overflow-hidden rounded-2xl bg-white border border-slate-200 shadow-[0_8px_30px_rgb(0,0,0,0.04)] col-span-1 ${spanClasses[i]} transition-all duration-300 hover:-translate-y-1 hover:shadow-xl`}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              <div className="p-7">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-display font-semibold text-2xl text-slate-900">{s.title}</h3>
                  <ArrowUpRight className="text-brand shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.75} />
                </div>
                <p className="mt-3 text-slate-600 leading-relaxed">{s.blurb}</p>
                <ul className="mt-5 flex flex-wrap gap-x-6 gap-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm font-medium text-slate-700">
                      <span className="grid place-items-center h-5 w-5 rounded-full bg-brand/10 text-brand">
                        <Check size={12} strokeWidth={3} />
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            data-testid="services-quote-button"
            onClick={scrollToQuote}
            className="rounded-xl bg-ink hover:bg-slate-800 text-white font-semibold px-8 py-4 transition-all duration-300 hover:-translate-y-1"
          >
            Request a Free Quote
          </button>
        </div>
      </div>
    </section>
  );
};
